import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FileText, Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ nome: '', email: '', empresa: '', whatsapp: '', password: '', confirm: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) {
      toast.error('As senhas não coincidem');
      return;
    }
    if (form.password.length < 6) {
      toast.error('A senha deve ter ao menos 6 caracteres');
      return;
    }
    setLoading(true);
    try {
      await register({ nome: form.nome, email: form.email, empresa: form.empresa, whatsapp: form.whatsapp, password: form.password });
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao criar conta');
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4"
         style={{ backgroundImage: 'radial-gradient(ellipse at 50% 50%, rgba(249,115,22,0.08) 0%, transparent 70%)' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/icon-192.png" alt="OrcFácil" className="w-32 h-32 rounded-2xl object-cover mb-4 mx-auto block shadow-[0_0_40px_rgba(249,115,22,0.35)]" />
          <h1 className="font-heading text-3xl font-bold text-white">OrcFácil</h1>
          <p className="text-zinc-500 mt-1 text-sm">15 dias grátis, sem cartão de crédito</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-8 space-y-4">
          <h2 className="font-heading text-xl font-semibold text-white">Criar conta</h2>

          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2">
              <label className="field-label">Nome completo</label>
              <input data-testid="nome-input" required className="field-input" placeholder="Seu nome" value={form.nome} onChange={set('nome')} />
            </div>
            <div className="col-span-2">
              <label className="field-label">Nome da empresa</label>
              <input data-testid="empresa-input" required className="field-input" placeholder="Sua empresa" value={form.empresa} onChange={set('empresa')} />
            </div>
            <div className="col-span-2">
              <label className="field-label">E-mail</label>
              <input data-testid="email-input" type="email" required className="field-input" placeholder="seu@email.com" value={form.email} onChange={set('email')} />
            </div>
            <div className="col-span-2">
              <label className="field-label">WhatsApp <span className="text-zinc-600">(para recuperação de senha)</span></label>
              <input data-testid="whatsapp-input" className="field-input" placeholder="(99) 99999-9999" value={form.whatsapp} onChange={set('whatsapp')} />
            </div>
            <div>
              <label className="field-label">Senha</label>
              <div className="relative">
                <input data-testid="password-input" type={showPass ? 'text' : 'password'} required className="field-input pr-8" placeholder="••••••" value={form.password} onChange={set('password')} />
                <button type="button" onClick={() => setShowPass(p => !p)}
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-zinc-300">
                  {showPass ? <EyeOff size={14} /> : <Eye size={14} />}
                </button>
              </div>
            </div>
            <div>
              <label className="field-label">Confirmar</label>
              <input data-testid="confirm-input" type="password" required className="field-input" placeholder="••••••" value={form.confirm} onChange={set('confirm')} />
            </div>
          </div>

          <button
            data-testid="register-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-orange-500 hover:bg-orange-400 disabled:opacity-50 text-white font-semibold py-2.5 px-4 rounded-xl transition-colors duration-150"
          >
            {loading ? 'Criando conta...' : 'Criar conta grátis — 15 dias free'}
          </button>

          <p className="text-center text-sm text-zinc-500">
            Já tem conta?{' '}
            <Link to="/login" className="text-orange-400 hover:text-orange-300 font-medium">Entrar</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
